import { EQUIPMENT_STATUS } from 'pages/AssetManagement/constants';

export const EQUIPMENT_TABLE_TABS_VALUES = {
  ALL: 'all',
  ACTIVE: EQUIPMENT_STATUS.ACTIVE,
  MAINTENANCE: EQUIPMENT_STATUS.MAINTENANCE,
  INACTIVE: EQUIPMENT_STATUS.INACTIVE,
} as const;

export const EQUIPMENT_TABLE_TABS = Object.entries(
  EQUIPMENT_TABLE_TABS_VALUES,
).map(([key, value]) => ({
  value,
  label: key,
}));

export const ARCHIVED_EQUIPMENT_TABLE_TABS = [
  { value: EQUIPMENT_TABLE_TABS_VALUES.ALL, label: 'ALL' },
];

export const MAP_ADDITIONAL_INFO_TO_TABS = {
  [EQUIPMENT_TABLE_TABS_VALUES.ALL]: 'all_equipments',
  [EQUIPMENT_TABLE_TABS_VALUES.ACTIVE]: 'active_equipments',
  [EQUIPMENT_TABLE_TABS_VALUES.MAINTENANCE]: 'maintenance_equipments',
  [EQUIPMENT_TABLE_TABS_VALUES.INACTIVE]: 'inactive_equipments',
};

/** React Router `location.state` key when opening equipment edit with a specific tab */
export const EQUIPMENT_EDIT_TAB_STATE_KEY = 'equipmentEditTab' as const;

export const REGISTRY_FORM_TABS = {
  BASIC_INFO: { value: 0, label: 'BASIC INFO' },
  DETAILED_INFO: { value: 1, label: 'DETAILED INFO' },
  EQUIPMENT_ATTACHMENTS: { value: 2, label: 'ATTACHMENTS' },
  INSPECTION_AND_FORMS: { value: 3, label: 'INSPECTION & FORMS' },
  DOCUMENTS_AND_CERTIFICATIONS: {
    value: 4,
    label: 'DOCUMENTS & CERTIFICATIONS',
  },
  MAINTENANCE: { value: 5, label: 'MAINTENANCE' },
};
